<!--suppress CssUnresolvedCustomProperty, JSUnusedAssignment, CssUnusedSymbol -->
<script context="module" lang="ts">
    import {writable} from 'svelte/store';

    // TODO remove
    let showAllTranslations = writable(true)
</script>

<script lang="ts">
    import WordLink from './WordLink.svelte';
    import {clickEffect} from './clickEffect';
    import './clickEffect.css'
    import AudioBrowseSentence from './AudioBrowseSentence.svelte';
    import {markWordLinkTranslation} from '$lib/utils/markWordLinkTranslation';
    import {ASSETS_HOST} from '../../../../../consts';
    import type {UserWordsMapStore} from '$lib/classes/stores/get-user-words-map';
    import {PunctMark, type Sentence} from '$lib/classes/data/sentence';
    import type {UserWord} from '$lib/classes/data/user-word';
    import type {CurrentWord} from '$lib/stores/currentWord';
    import {getContext} from 'svelte';
    import {keyUserActionProcessor} from '$lib/context-keys';
    import type {UserActionProcessor} from '$lib/classes/services/user-action-processor';

    export let currentWord: CurrentWord
    export let userWordsMap: UserWordsMapStore
    export let sentence: Sentence
    export let userWord: UserWord | undefined

    const userActionProcessor: UserActionProcessor = getContext(keyUserActionProcessor)

    $: currentSentenceId = userWord?.sentenceId
    $: currentSentence = currentSentenceId === sentence.id
    $: imgNr = sentence.imgNr

    $: currentWordId = $currentWord!.id
    $: currentWordLink = sentence.wordLinks.find(wordLink => wordLink.id === currentWordId)

    $: translation = markWordLinkTranslation(sentence.t!, currentWordLink?.t!)

    let showOwnTranslation = false

    function handleSentenceClick(event: MouseEvent) {
        const markedAsKnown = userWord?.status.toString() === 'KNOWN'
        if (markedAsKnown) {
            clickEffect(event, 'Word already marked as \'KNOWN\'')
        }
        userActionProcessor.saveSentence(currentWordId, sentence.id)
    }

</script>

<!-- svelte-ignore a11y-click-events-have-key-events  a11y-no-static-element-interactions -->
<div class="sentence"
     on:click={handleSentenceClick}
>

    <div class="parts-and-translation"
         class:current-sentence={currentSentence}
    >

        <div class="img-wrapper">
            {#if imgNr}
                <img src={`${ASSETS_HOST}/img/100/${imgNr}.jpg`} alt="">
            {/if}
        </div>

        <div class="img-marker"
             class:filled={imgNr}
        >
        </div>

        <div class="sentence-parts">
            {#each sentence.parts as part, index}
                {#if part instanceof PunctMark}
                    <span class="sentence-part">{part.pmark}</span>
                {:else}
                    <WordLink
                            userWordsMap={userWordsMap}
                            part={part}
                            currentWordId={currentWordId}
                    />
                {/if}
            {/each}
        </div>

        <div class="sentence-translation" class:show-translation={showOwnTranslation || $showAllTranslations}>
            {@html translation}
        </div>

        <!--        <ShowHideOwnTranslation bind:showOwnTranslation {showAllTranslations}/>-->
        <AudioBrowseSentence sentenceId={sentence.id}/>

    </div>

</div>


<style>

    .sentence {
        display: flex;
        margin-bottom: .5rem;
        cursor: pointer;
        transition: opacity 100ms;
        overflow: visible;
        user-select: none;
        /*background: #638ca6;*/
        /*border: 1px solid teal;*/
    }

    .sentence :global(.play-audio-btn),
    .sentence :global(.show-own-translation-btn) {
        display: none;
    }

    .sentence:hover :global(.play-audio-btn),
    .sentence:hover :global(.show-own-translation-btn) {
        display: initial;
    }

    .sentence:hover .parts-and-translation {
        background: var(--color-hover);
    }

    .parts-and-translation {
        position: relative;
        width: min(70%, 550px);
        margin-left: 20%;
        padding: 1.1rem 1.2rem 1.1rem 1.2rem;
        border: 2px solid transparent;
        border-radius: var(--border-radius);
        /*border: 1px solid orange;*/
    }

    /*noinspection CssUnusedSymbol*/
    :global(.sentence-part) {
        line-height: 1.5;
        user-select: none;
        -webkit-user-select: none;
    }

    .current-sentence {
        border-color: var(--color-accent);
        background: var(--color-lighter);
    }

    .current-sentence img {
        visibility: visible;
    }

    .img-wrapper {
        position: absolute;
        width: 6rem;
        height: 6rem;
        top: 50%;
        left: 0;
        display: flex;
        align-items: center;
        transform: translate(-100%, -50%);
        /*border: 1px solid darkmagenta;*/
    }

    .sentence:hover .img-wrapper {
        z-index: 11;
    }

    .sentence:hover img {
        /*box-shadow: 0 0 0 4px white;*/
        visibility: visible;
    }

    img {
        width: 5rem;
        height: 5rem;
        border-radius: var(--border-radius);
        visibility: hidden;
    }

    .img-marker {
        position: absolute;
        width: .4rem;
        height: .8rem;
        border-radius: 2px;
        opacity: .25;
        transform: translate(-1.4rem, .35rem);
    }

    .img-marker.filled {
        background: var(--color-accent);
    }

    .sentence:hover .img-marker {
        background: transparent;
    }

    .current-sentence .img-marker {
        background: transparent;
    }

    .sentence-translation {
        font-size: .95rem;
        font-style: italic;
        color: var(--color-darker);
        user-select: none;
        -webkit-user-select: none;
        line-height: 0;
        opacity: 0;
        margin-top: 0;
        overflow: hidden;
        transition: all 250ms;
        /*border: 1px solid purple;*/
    }

    .sentence-translation :global(.word-link-translation) {
        font-weight: var(--font-bold);
        color: var(--color-word-link-translation);
    }

    .show-translation {
        line-height: 1.2;
        opacity: 1;
        margin-top: 8px;
    }

</style>


